import React from 'react';
import './App.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Product from './components/Product/Product';
import Cart from './components/Cart/Cart';
import Header from './components/Header/Header';
import {loadUser} from "./store/actions/user";
import {connect} from "react-redux";
import Landing from "./components/Landing/Landing";
import OrderForm from "./components/OrderForm/OrderForm";


class App extends React.Component {

    componentDidMount() {
        this.props.loadUser()
    }

    render() {
        let routes = (
            <Switch>
                <Route exact path="/" component={Landing}/>
                <Route exact path="/products/:id" component={Product}/>
                <Route exact path="/cart" component={Cart}/>
                <Route exact path="/order-form/:id" component={OrderForm}/>
            </Switch>
        );

        return (
            <div className="App">
                <BrowserRouter>

                    <div className="routes">
                        <Header/>
                        {routes}
                    </div>
                </BrowserRouter>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {
        loadUser: () => dispatch(loadUser()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
